module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_saga-48eb7a6924da89783376d9bd91801cc0.png";